import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import { commentMarkup } from "@ext/markdown/elements/sourceComment/logic/commentText";

// A comment is Markdown's own, not a Gramax tag, so every syntax writes it the same way. `text` puts
// the container's indentation back on each line the reader took it from.
export const sourceCommentFormatter: NodeSerializerSpec = (state, node) => {
	state.text(commentMarkup(node.attrs.text), false);
	state.closeBlock(node);
};

export const inlineSourceCommentFormatter: NodeSerializerSpec = (state, node) => {
	state.text(commentMarkup(node.attrs.text), false);
};
